import { Auth } from '../src/api/Auth';
import { ContentManager } from "../src/helpers/ContentManager";
import { getUserToken } from "../src/api/Token";
import { Api } from "../src/api/Api";
import { dropDownInit } from "../src/listners/dropDown";
import { GetDataHelper } from "../src/helpers/GetDataHelper";
import {initInterface} from "../src/initInterface";
import {setAuthRegButtonListeners} from "../src/listners/setAuthRegButtonListeners";
import {initGlobalStore} from "../src/store";
import {resolveTopBar} from "../src/functions/resolveTopBar";

window.content = new ContentManager();
window.auth = new Auth();
window.DataHelper = new GetDataHelper();
window.api = new Api();

// initInterface(); // jquery legacy
initGlobalStore();

setAuthRegButtonListeners(setPage);

function main() {
    Promise.all([api.getUserProfile(), api.getUsersBonusBalance()]).then(() => {
        content.setProfileHeader(DataHelper.store.user, DataHelper.store.bonuses);
        content.hideModalWindows(false);
    })
      .catch(error => console.log("error on auth check: ", error))
      .finally(setPage);
}

function setPage() {
    resolveTopBar().then(() => {
        const queryParams = new URLSearchParams(window.location.search);
        const lang = localStorage.getItem('currentLang') || 'ru';
        if (queryParams.has('id')) {
            document.querySelector('h1').style.display = 'none'
            const id = queryParams.get('id');
            api.getPromotion(id, lang).then(({ stock }) => {
                content.setPromotion(stock);
            }).catch(() => location.assign('/promotions.html'));
        } else {
            document.querySelector('h1').style.display = 'block'
            api.getPromotions(lang).then(({stocks}) => {
                content.setPromotions(stocks);
            });
        }
    })
}


main();
